package com.neurobs.ccabserver.transcriptreview.states

import com.neurobs.ccabserver.transcriptreview.util.NonEditableTranscript
import com.neurobs.react.{GenericState, GenericStateGenerator, StateAttribute}
import org.scalajs.dom.console
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.Hooks._
import slinky.core.facade.ReactElement

case class ConfidenceScreenState (
  confidenceThresholdState: StateAttribute[Double],
  transcriptIndexState: StateAttribute[Option[Int]]
                                 ) extends GenericState {

  def nonConfidentWords(casrTranscript: NonEditableTranscript) = casrTranscript.transcriptWords.filter(_.confidence < confidenceThresholdState.value)

  def nextIndex(casrTranscript: NonEditableTranscript) = {
    val nextIndex = transcriptIndexState.value match {
      case Some(transcriptIndex) =>
        val words = nonConfidentWords(casrTranscript)
        val incremented = transcriptIndex + 1
        val nextIndex = if (incremented < words.length) incremented else 0
        nextIndex
      case None => 0
    }
    transcriptIndexState.setValue(Some(nextIndex))
    nextIndex
  }

  def prevIndex(casrTranscript: NonEditableTranscript) = {
    val prevIndex = transcriptIndexState.value match {
      case Some(transcriptIndex) =>
        val words = nonConfidentWords(casrTranscript)
        val prevIndex = {
          if (words.isEmpty) 0
          else {
            val decremented = transcriptIndex - 1
            if (decremented < 0) words.length - 1 else decremented
          }
        }
        prevIndex
      case None => 0
    }
    transcriptIndexState.setValue(Some(prevIndex))
    prevIndex
  }

  def wordAtIndex(index: Int, casrTranscript: NonEditableTranscript) = nonConfidentWords(casrTranscript).lift(index)

  def setConfidenceThreshold(threshold: Double) = {
    if (threshold >= 0 && threshold <= 1) confidenceThresholdState.setValue(threshold)
  }
}

object ConfidenceScreenStateGenerator extends GenericStateGenerator[ConfidenceScreenState] {
  override def generateEmptyDefaultState(): ConfidenceScreenState = ConfidenceScreenState(
    emptyDefaultState(0),
    emptyOptionDefaultState[Int]()
  )
}

@react
object ConfidenceScreenStateProvider {
  case class Props(children: ReactElement*)
  val component = FunctionalComponent[Props] { props =>

    val confidenceThresholdState = StateAttribute(useState[Double](.9))
    val transcriptIndexState = StateAttribute(useState[Option[Int]](None))

    val confidenceScreenState = ConfidenceScreenState(
      confidenceThresholdState = confidenceThresholdState,
      transcriptIndexState = transcriptIndexState
    )

    ConfidenceScreenStateGenerator.Provider(confidenceScreenState)(
      props.children:_*
    )
  }
}
